import SinglePageDescriptionView from './SinglePageDescriptionView'


export default SinglePageDescriptionView
